// import { createRouter, createWebHistory } from 'vue-router';
//
// // 导入页面组件

//
//
// // 定义路由
// const routes = [
//   {
//     path: '/',
//     name: 'Home',
//     component: Login,
//     // meta: {
//     //   requiresAuth: true, // 需要登录
//     // },
//   },
//   {
//     path: '/login',
//     name: 'Login',
//     component: Login,
//   },
//
// ];
//
// // 创建路由实例
// const router = createRouter({
//   history: createWebHistory(), // 使用 HTML5 模式
//   routes,
// });
//
//
//
// export default router;











import { createRouter, createWebHashHistory } from 'vue-router';  // 使用 hash 模式
// import { createRouter, createWebHistory } from 'vue-router';
import Login from '../components/LoginView.vue';
// import Layout from "@/components/Navbar.vue"; // 主布局组件
import TrainingPlan from "@/views/TrainingPlan.vue"; // 培训计划页面
import StudyStatus from "@/views/StudyStatus.vue"; // 学习情况页面
import ExamRecord from "@/views/ExamRecord.vue"; // 考试记录页面
import Profile from "@/views/Profile.vue"; // 个人中心页面
import AnserView from "@/views/AnserView.vue"; // 答题中心页面
import ManageView from '@/components/ManageView/UserManage.vue'
// import Navbar from "../components/Navbar.vue";
import VideoPlay from "../components/VideoShow.vue";
import z from "../components/MainLayout.vue";
import MG from '@/components/ManaGerView.vue'
import as from '@/components/QuestionAndAnser.vue'
import test from '@/components/ManageView/TestView.vue'
import face from '@/components/FaceGet.vue'
// import testt from '@/views/testt.vue'
import Super from '@/components/SuperManager.vue'
import zc from '@/components/Regist.vue'
import ask from '@/components/ManageView/askView.vue'
import superExam from '@/components/Super/Information/SuperExamView.vue'
// import FileManager from '@/views/zhbbtest.vue'
import VideoView from '@/components/ManageView/VideoView.vue'
const routes = [
  // {
  //   path: "/",
  //   component: Navbar,
  //   redirect: "/Navbar", // 默认路由跳转
  //   meta: { title: "首页" }, // 你可以根据需要修改首页标题
  // },
  {
    path: "/zc",
    name: "zc",
    component: zc,
    meta: { title: "注册" },
  },
  {
    path: "/SE",
    name: "superExam",
    component: superExam,
    meta: { title: "超级管理员考试管理" },
  },
  {
    path: "/",
    name: "主界面",
    redirect: "/MgLogin",
    meta: { title: "注册" },
  },
  {
    path: "/v",
    name: "VideoView",
    component: VideoView,
    meta: { title: "审核" },
  },

  {
    path: "/ask",
    name: "ask",
    component: ask,
    meta: { title: "咨询" },
  },
  {
    path: "/training-plan",
    name: "TrainingPlan",
    component: TrainingPlan,
    meta: { title: "培训计划" },
  },

  // {
  //   path: "/FileManager",
  //   name: "FileManager",
  //   component: FileManager,
  //   meta: { title: "FileManager" },
  // },


  {
    path: "/Super",
    name: "Super",
    component: Super,
    meta: { title: "超级管理员" },
  },


  {
    path: "/MGLogin",
    name: "Login",
    component: Login,
    meta: { title: "管理员登录" },
  },  {
    path: "/face",
    name: "face",
    component: face,
    meta: { title: "人脸" },
  },

  {
    path: "/as",
    name: "as",
    component: as,
    meta: { title: "考试" },
  }, {
    path: "/test",
    name: "test",
    component: test,
    meta: { title: "考试z" },
  },
  {
    path: "/MG",
    name: "MG",
    component: MG,
    meta: { title: "管理员界面" },
  },

  //
  // {
  //   path: "/Navbar",
  //   name: "Navbar",
  //   component: Navbar,
  //   meta: { title: "Navbar" },
  // },
  {
    path: "/study-status",
    name: "StudyStatus",
    component: StudyStatus,
    meta: { title: "学习情况" },
  },{
    path: "/um",
    name: "ManageView",
    component: ManageView,
    meta: { title: "用户管理" },
  },
  {
    path: "/exam-record",
    name: "ExamRecord",
    component: ExamRecord,
    meta: { title: "考试记录" },
  }, {
    path: "/anser",
    name: "AnserView",
    component: AnserView,
    meta: { title: "考试界面" },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { title: "个人中心" },
  },{
    path: "/VideoPlay",
    name: "VideoPlay",
    component: VideoPlay,
    meta: { title: "视频学习" },
  },{
    path: "/z",
    name: "z",
    component: z,
    meta: { title: "z" },
  },

];


// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(), // 使用 HTML5 模式
  routes,
});

// 修改页面标题
router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title; // 动态设置页面的 title
  }
});

export default router;

